export default __webpack_public_path__ + "static/media/unify.2b686f72.svg";